/*
  786 Motion Plus - shade wall + generic tab strips
  ------------------------------------------------
  The product carousel has its own file (786-motion-ptb.js).
  Nothing here replaces a section's logic: it watches the class changes
  the sections make and animates around them.
*/
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.classList.contains('motion-off')) return;
  var G = window.gsap;
  if (!G) return;

  var EASE = 'power3.out';
  function q(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function one(s, r) { return (r || document).querySelector(s); }

  function scrollXTo(el, to, dur) {
    var o = { v: el.scrollLeft };
    G.to(o, { v: to, duration: dur || 0.6, ease: EASE, overwrite: true,
      onUpdate: function () { el.scrollLeft = o.v; } });
  }

  function pop(btn) {
    G.fromTo(btn, { scale: 0.94 }, { scale: 1, duration: 0.55, ease: 'elastic.out(1, 0.6)' });
  }

  /* Centre the clicked tab, but only in a strip that really scrolls. */
  function centre(btn) {
    var win = btn.closest('.ptb786-tabs-window, .s786-tabs, .s786-coll__tabs, .j-chips');
    if (!win) return;
    var ox = getComputedStyle(win).overflowX;
    if (ox !== 'auto' && ox !== 'scroll') return;
    if (win.scrollWidth <= win.clientWidth + 4) return;
    var t = btn.offsetLeft - (win.clientWidth - btn.offsetWidth) / 2;
    scrollXTo(win, Math.max(0, Math.min(t, win.scrollWidth - win.clientWidth)), 0.6);
  }

  function revealIn(items, stagger) {
    if (!items.length) return;
    G.killTweensOf(items);
    G.fromTo(items,
      { autoAlpha: 0, y: 26, scale: 0.97 },
      { autoAlpha: 1, y: 0, scale: 1, duration: 0.7, ease: EASE,
        stagger: { each: stagger || 0.05, from: 'start' }, clearProps: 'transform' });
  }

  /* --------------------------------------------- shade wall underline */
  function shadeTabs(root) {
    q('.s786-shades', root).forEach(function (s) {
      if (s.dataset.mpTabs) return;
      s.dataset.mpTabs = '1';
      var nav = one('.s786-tabs', s);
      var line = one('.s786-tabs__line', s);
      if (!nav) return;

      function moveLine() {
        var act = one('.s786-tabs__item.is-active', nav);
        if (!act || !line) return;
        G.to(line, {
          x: act.offsetLeft, width: act.offsetWidth,
          duration: 0.7, ease: 'elastic.out(1, 0.85)', overwrite: true
        });
      }

      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.s786-tabs__item');
        if (!btn) return;
        pop(btn);
        centre(btn);
        setTimeout(function () {
          moveLine();
          var live = q('.s786-swatch', s).filter(function (sw) {
            return !sw.classList.contains('is-dim');
          });
          revealIn(live.slice(0, 80), 0.012);
        }, 30);
      });

      window.addEventListener('resize', function () { G.delayedCall(0.2, moveLine); });
      G.delayedCall(0.4, moveLine);
    });
  }

  /* ------------------------------------------- generic chip/tab strips */
  function genericTabs(root) {
    q('.s786-coll__tabs, .j-chips, .s786-pdp__tabs .s786-tabs', root).forEach(function (nav) {
      if (nav.dataset.mpTabs) return;
      nav.dataset.mpTabs = '1';
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('a, button');
        if (!btn) return;
        pop(btn);
        centre(btn);
      });
    });
  }

  function boot(root) {
    root = root || document;
    try { shadeTabs(root); genericTabs(root); }
    catch (e) { if (window.console) console.warn('[786 tabs]', e); }
  }

  window.MotionTabs = { boot: boot, revealIn: revealIn, pop: pop, centre: centre, scrollXTo: scrollXTo };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
